module.exports = __webpack_public_path__ + "static/img/teacher7.f786f702.png";